import Honeybadger from "@honeybadger-io/js";

export const request = (method, path, body, setUnauthorized = () => {}, fileFieldNames = []) => {
  const requestOptions = {
    method: method,
    credentials: 'include',
    redirect: 'follow'
  };

  if (body) {
    requestOptions.body = body
  }

  if (!(body instanceof FormData)) {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("App-Version", process.env.REACT_APP_COMMIT_HASH);

    requestOptions.headers = headers
  }

  let successfulResponse;

  return fetch(`${process.env.REACT_APP_ROOT_DOMAIN}${path}`, requestOptions)
    .then(response => {
      if (response.ok) {
        successfulResponse = true;
        checkAppForceRefresh(response);

        if (response.status === 204) {
          return
        }

        return response.json();
      }
      else if (response.status === 401) {
        setUnauthorized(true)
        return response.json()
      }
      else if (response.status === 413) {
        if (fileFieldNames.length > 0) {
          const errorMessage = get413ErrorMessage(fileFieldNames, body);

          const errors = {};
          fileFieldNames.forEach(field => {
            const fieldName = extractRailsFieldName(field);
            errors[fieldName] = [errorMessage];
          });

          return errors;
        }

        throw new Error("File size exceeds limit");
      }
      else if (response.status.toString()[0] === "4") {
        return response.json()
      }
      else {
        throw new Error('Something went wrong ...');
      }
    })
    .then(data => {
      if (successfulResponse) {
        return Promise.resolve(data)
      }
      return Promise.reject(data)
    })
}

const get413ErrorMessage = (fileFieldNames, body) => {
  if (fileFieldNames.length > 1 || body.getAll(fileFieldNames[0]).length > 1) {
    return "can't be saved because combined size of files uploaded exceed the request size limit, please try uploading them separately";
  }

  return "can't be saved because file size is too large";
};

const extractRailsFieldName = (field) => {
  // For example, we want 'ticket_actions.image' for 'ticket[ticket_actions_attributes][][image]', 'image' for 'ticket[image]' and  'images' for 'user_mass_mail[images][]' 
  const parts = field.match(/[^[\]]+/g) || [];
  let cleaned = parts.slice(1);
  cleaned = cleaned.map(pieces => pieces.replace(/_attributes$/, '')).filter(pieces => pieces !== '');
  if (cleaned.length > 1) {
    return `${cleaned[0]}.${cleaned[cleaned.length - 1]}`;
  }

  return cleaned[0];
};

const checkAppForceRefresh = (response) => {
  const forceRefreshTime = response.headers.get("X-App-Force-Refresh");
  const previousForceRefreshTime = localStorage.getItem("last_force_refresh_time");

  if (forceRefreshTime > previousForceRefreshTime) {
    localStorage.setItem("last_force_refresh_time", forceRefreshTime);
    window.location.reload();
  }
};

// Send unforseen errors to Honeybadger
export const reportErrorToHoneybadger = (error) => {
  if (error instanceof Error && !["Something went wrong ...", "File size exceeds limit"].includes(error.message)) {
    Honeybadger.notify(error)
  }
}

// Set error or errors automatically
export function handleRequestErrors(_this, error, extraParams) {
  reportErrorToHoneybadger(error)

  if (error instanceof Error) {
    _this.setState({ error: error, ...extraParams })
  }
  else {
    _this.setState({ errors: error, ...extraParams })
  }
}
